import { useMutation } from "@tanstack/react-query";
import { MailWarning } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";
import { api } from "@/lib/api";
import { cn } from "@/lib/cn";
import { t } from "@/i18n/id";

/** Unverified email: publishing is blocked until the link is clicked, so say so everywhere the user works. */
export function VerifyEmailBanner({ className }: { className?: string }) {
  const { user } = useAuth();
  const resend = useMutation({ mutationFn: () => api.auth.resendVerification(), meta: { success: t.auth.verifyResent } });
  if (!user || user.emailVerified) return null;
  return (
    <div className={cn("border-b border-amber-600/15 bg-warning-soft/60 px-4 py-2 text-[13px] text-amber-950", className)}>
      <div className="mx-auto flex max-w-[1120px] flex-wrap items-center gap-x-3 gap-y-1">
        <MailWarning className="size-4 shrink-0" aria-hidden="true" />
        <span className="font-medium">{t.auth.verifyBanner(user.email)}</span>
        <button type="button" className="min-h-8 font-semibold underline underline-offset-2 disabled:opacity-60" disabled={resend.isPending || resend.isSuccess} onClick={() => resend.mutate()}>
          {resend.isSuccess ? t.auth.verifyResent : t.auth.verifyResend}
        </button>
      </div>
    </div>
  );
}
